import React from 'react';
import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';

import FormCrearTraspaso from './FormCrearTraspaso';
import insertTraspaso from '../../../graphql/mutations/rrhh/insertTraspaso.graphql';
import getTraspasos from '../../../graphql/querys/rrhh/getTraspasos.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import validarPendiente from '../../../graphql/querys/rrhh/validarPendiente.graphql';

@compose(
  graphql(insertTraspaso, {
    name: 'insertTraspaso',
    options: {
      refetchQueries: [{ query: getTraspasos }],
    },
  }),
  graphql(getUsuario)
)
class CrearTraspaso extends React.Component {
  onSubmit = values => {
    let nuevaFecha = values.fechaEstimada.toDate();
    let nuevoObj = {
      ...values,
      fechaEstimada: nuevaFecha,
    };

    this.props.client
      .query({
        query: validarPendiente,
        variables: {
          idOrganismo: nuevoObj.idOrganismo,
        },
      })
      .then(res => {
        // console.log('response', res);
        if (res.data.validarPendiente) {
          Modal.error({
            title: 'Error en la creación del traspaso',
            content:
              'Lamentamos informarle que ya existe un traspaso con estado pendiente, deberá confirmar el traspaso actual antes de crear uno nuevo',
          });
        } else {
          this.props
            .insertTraspaso({
              variables: {
                objTraspaso: nuevoObj,
              },
            })
            .then(res => {
              if (res.data.insertTraspaso._id) {
                notification.success({
                  message: 'Traspaso Registrado',
                  description:
                    'El traspaso se registró correctamente en la base de datos',
                });
                this.props.history.push('/');
              }
            })
            .catch(err => {
              console.log('Existió un error a la hora de crear el traspaso');
              console.log(err);

              Modal.error({
                title: 'Error en la creación del traspaso',
                content:
                  'Lamentamos informarle que la operación que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuníquese con el departamento de informática para obtener mas detalles.',
              });
            });
        }
      })
      .catch(err => {
        console.log(
          'Existió un error a la hora de validar si hay traspasos pendientes'
        );
        console.log(err);

        Modal.error({
          title: 'Error en la creación del traspaso',
          content:
            'Lamentamos informarle que la operación que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuníquese con el departamento de informática para obtener mas detalles.',
        });
      });
  };

  render() {
    return (
      <div>
        <br />
        <FormCrearTraspaso
          history={this.props.history}
          onSubmit={this.onSubmit}
        />
      </div>
    );
  }
}

export default withApollo(CrearTraspaso);
